export enum Environment {
  Development = 'development',
  Production = 'production',
  Test = 'test',
}
export interface LibraryConfig {
  environment: Environment
  baseURL: string
  storageNS?: string
  /**
   * Invocata quando il backend risponde 401 su una chiamata applicativa
   * (esclusi login e chiamate con `skipError`). Permette all'app di reagire
   * alla sessione scaduta senza che la libreria conosca il router.
   */
  onUnauthorized?: () => void
}

let currentConfig: LibraryConfig = {
  environment: Environment.Development,
  baseURL: process.env.NEXT_PUBLIC_SERVICES_URL || 'http://localhost:3000/api',
  storageNS: 'sd',
}

export const setConfig = (config: Partial<LibraryConfig>) => {
  currentConfig = { ...currentConfig, ...config }
  console.log('🚀 ~ setConfig ~ currentConfig:', currentConfig)
}

export const getConfig = (): LibraryConfig => currentConfig
